import React, { createContext, useContext, useState, useEffect } from "react";
import { getWishlist } from "../api";
//import { AuthContext } from '../../auth/context/AuthContext';
const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  //const { isAuthenticated,user} = useContext(AuthContext);
 // console.log("isAuthenticated",isAuthenticated);
  const [wishlistCount, setWishlistCount] = useState(0);
  

  const fetchWishlist = async () => {
    const isAuthenticated = sessionStorage.getItem("isAuthenticated") === "true";
    if (!isAuthenticated) {
      return
    }

    try {
      const data = await getWishlist();
      setWishlistCount(data.length);
    } catch (error) {
      console.error("Error fetching wishlist count:", error);
    }
  };

  useEffect(() => {
    // if (!isAuthenticated || !user) {
    //   return;
    // }
    fetchWishlist(); // Initial fetch

    // Listen for wishlist updates
    const handleWishlistUpdate = () => {
      fetchWishlist(); // Re-fetch wishlist count when event is triggered
    };

    window.addEventListener("wishlistUpdated", handleWishlistUpdate);

    return () => {
      window.removeEventListener("wishlistUpdated", handleWishlistUpdate);
    };
  }, []);

  return (
    <WishlistContext.Provider value={{ wishlistCount}}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
